import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectToGrades from "./routes/SubjectsToGrades";
import ScopeAndSequence from "./routes/ScopeAndSequence";
import DPSubjectsSetup from "./routes/DPSubjectsSetup";
import Sync from "./routes/Sync";
export default store => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "school-onboard-setup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    SubjectToGrades(store),
    ScopeAndSequence(store),
    Sync(store),
    DPSubjectsSetup(store),
  ],
});
